<script setup>
  import { ref, computed } from "vue";

  const props = defineProps({
    show: {
      type: Boolean,
      required: true,
    },
    maskClosable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Modal",
    },
    /** size
     * xl: 1200px
     * lg: 1000px
     * md: 800px
     * sm: 600px
     * xm: 500px
     * xs: 420px
     */
    size: {
      type: String,
      default: "md",
    },
    /** 모달 내부에 동적 입력(에디터 등)이 있을 때 포커스 트랩을 끄려면 false */
    trapFocus: {
      type: Boolean,
      default: true,
    },
  });

  const emits = defineEmits(["update:show"]);

  const segmented = ref({
    content: "soft",
    footer: "soft",
  });

  const bodyStyle = computed(() => {
    const sizeMap = {
      xl: "1200px",
      lg: "1000px",
      md: "800px",
      sm: "600px",
      xm: "500px",
      xs: "420px",
    };
    return {
      width: sizeMap[props.size] || "800px",
      "--n-title-font-weight": "700",
      "--n-title-font-size": "1.25rem",
      "--n-border-radius": "1rem",
      "--n-padding-left": "2rem",
      "--n-padding-right": "2rem",
      "--n-padding-bottom": "1rem",
      "--n-padding-top": "1.125rem",
      "--n-close-icon-size": "1.25rem",
      "--n-close-size": "2rem",
      "--n-font-size": "1rem",
      "--n-text-color": "var(--smoe-gray-800)",
    };
  });

  const localShow = computed({
    get: () => props.show,
    set: (val) => emits("update:show", val),
  });

  const handleUpdateShow = (val) => {
    localShow.value = val;
    emits("update:show", val);
  };
</script>

<template>
  <n-modal
    :auto-focus="false"
    :trap-focus="trapFocus"
    :mask-closable="!maskClosable"
    :bordered="false"
    :segmented="segmented"
    :style="bodyStyle"
    :title="title"
    class="ui-modal"
    preset="card"
    transform-origin="center"
    v-model:show="localShow"
    @update:show="handleUpdateShow"
  >
    <template #header>
      <slot name="header"></slot>
    </template>
    <slot name="body"> Default content </slot>
    <template #footer>
      <slot name="footer"></slot>
    </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </n-modal>
</template>

<style lang="scss">
  .ui-modal.n-card {
    overflow: hidden;
    max-height: 90vh;
    &.n-card--content-soft-segmented {
      & > .n-card__content {
        margin: 0;
        padding: 1.5rem 2rem;
        max-height: 80dvh;
        overflow: auto;
      }
      & > .n-card__footer {
        margin: 0;
        padding: var(--n-padding-top) var(--n-padding-left)
          var(--n-padding-bottom) var(--n-padding-left);
      }
    }
  }   
  .notice-modal.n-card {
    &.n-card--content-soft-segmented {
      & > .n-card__footer {
         border-top: 0 !important;
      }
    }
  }
</style>
